import { FC, useCallback } from 'react';
import Button from 'src/components/design-system/Button';
import Dialog from 'src/components/design-system/Dialog';
import useRedirect from 'src/hooks/useRedirect';

interface CreatePoProps {
  openModal: boolean;
  closeModal: () => void;
}

const CreatePo: FC<CreatePoProps> = ({ openModal, closeModal }) => {
  const { redirect, getUrl } = useRedirect();
  const handleCreatePo = useCallback(() => {
    redirect(getUrl('manageSupplier'), false, true);
    closeModal();
  }, [closeModal, getUrl, redirect]);

  return (
    <Dialog width="500px" title={'Create PO'} open={openModal} onClose={closeModal} id="modal">
      <div className="p-3">
        <p className="text-sm font-semibold mb-2">
          You have not selected a PO. In order to create a receipt, there must be a PO for you to
          receive against. Please click the Create PO button below to go to the PO module.
        </p>
        <div className="w-full flex justify-center">
          <Button color="primary" onClick={handleCreatePo}>
            Create PO
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default CreatePo;
